import {ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {BotatoChatManagerService} from 'botato-angular-lib';
import {Observable} from 'rxjs';
import {LearnAuthService} from '../../../core/authentication/learn-auth.service';
import {ChatStartService} from '../../../../../../micromate-learn-lib/src/lib/components/chatbot/chat-start.service';
import {NavigationService} from '../../../core/navigation.service';
import {LIB_AUTH_SERVICE_TOKEN} from '../../../../../../micromate-learn-lib/src/lib/components/chatbot/libAuthService';
import {LoggerRessource} from '../../../../../../micromate-learn-lib/src/lib/services/rest/logger-ressource.service';
import {BotIdService} from '../../../../../../micromate-learn-lib/src/lib/services/BotIdService';
import {BrandingService} from '../../../../../../micromate-learn-lib/src/lib/services/branding/branding.service';

@Component({
    templateUrl: './learning-container.component.html',
    styleUrls: ['./learning-container.component.scss'],
    standalone: false
})
export class LearningContainerComponent implements OnInit {
    private static LEARN_BOT_ID = 'learn';

    public alreadyConnected$: Observable<boolean>;
    public isConnected: boolean = false;
    public actionInProgress: boolean = false;

    constructor(private chatManagerService: BotatoChatManagerService,
                private navService: NavigationService,
                private chatStartService: ChatStartService,
                @Inject(LIB_AUTH_SERVICE_TOKEN) public authService: LearnAuthService,
                private logger: LoggerRessource,
                private botIdService: BotIdService,
                public brandingService: BrandingService,
                private changeDetectorRef: ChangeDetectorRef) {
        this.alreadyConnected$ = this.chatManagerService.alreadyConnectChanged$;
    }

    public ngOnInit(): void {
        this.botIdService.setBotId(LearningContainerComponent.LEARN_BOT_ID);
        // TODO MIC-2094
        void this.asyncNgOnInit();
    }

    private async asyncNgOnInit(): Promise<void> {
        this.chatManagerService.authenticationFailed$.subscribe(() => {
            this.logger.logFrontendInfoToBackend('Logout user as the websocket did not authenticate properly', this.authService.getAuthenticatedUser());
            this.authService.startLogoutFlow();
        });

        this.chatManagerService.setAccessTokenProvider(async () => {

            if (!this.authService.hasValidTokens()) {
                this.authService.startLogoutFlow();

                // eslint-disable-next-line @typescript-eslint/no-unused-vars,@typescript-eslint/no-empty-function
                return new Promise((resolve) => {
                });
            }
            const accessToken = this.authService.getAccessToken();
            this.logger.logFrontendInfoToBackend('Initialized websocket', this.authService.getAuthenticatedUser());
            return `Bearer ${accessToken}`;
        });

        const botId = this.botIdService.getBotId();
        this.chatManagerService.setBotId(botId);
        this.isConnected = await this.chatManagerService.connect();
        this.changeDetectorRef.markForCheck();
    }

    public async reconnect(): Promise<void> {
        this.actionInProgress = true;
        this.isConnected = await this.chatManagerService.connect(true);
        this.chatManagerService.clearDialog();
        this.chatStartService.setOpenState(true);
        await this.chatManagerService.start();
        this.navService.navigateToChat(false);
        this.actionInProgress = false;
        this.changeDetectorRef.markForCheck();
    }
}
